import type { GQLAppFeature } from 'src/generated/graph-api';
import { useHasAccessToFeatureQuery } from './index.generated';

export function useHasAccessToFeature(feature: GQLAppFeature) {
  const { data, loading } = useHasAccessToFeatureQuery({
    variables: { feature },
  });

  if (loading) {
    return undefined;
  }

  return Boolean(data?.me?.record?.hasAccessToFeature);
}
